import { qaOktaConfig } from "src/app/core/configs/oktaConfig/qaOktaConfig";

export const environment = {
    production: false,
    environment: 'qa',
    oktaConfig: qaOktaConfig,
    apiGateWayBaseURL: 'https://greenlight-api-qa.wbd.com',
    s3BucketUrl: 'https://greenlight-assets-qa.wbd.com',
    cognitoBurbank:179,
    cognitoCostume:182,
    cognitoHotlock:175,
    openUser:201,
    parkingForm:217,
    cognitoBurbankStudios: 251,
    cognitoRanch: 254,
    signoutSession: '0oa26avnmsikvoiQC0h8',
    signoutUrl: 'https://loginqa.wbd.com/logout.aspx'
};
